
import React, { useState, useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Table } from 'react-bootstrap';
import { authKey, DOWNLOAD_DOCUMENT, GET_DELIVERY_CHALLAN_LIST, GET_STAKEHOLDER_CATEGORY } from '../../../common/URLs';
import Moment from 'moment';
import jwt from 'jwt-decode';
import SearchIcon from "@mui/icons-material/Search";
import moment from 'moment';
// import { Button, Box, Card, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PIT_ROLES, PROD } from "../../../common/constants";
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
// import { TextField } from '@mui/material'
// import DatePicker from "react-multi-date-picker";
// import DatePanel from "react-multi-date-picker/plugins/date_panel"
import { Container, Card, CardContent, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, Button, IconButton, Tooltip, Link } from '@mui/material';
import { useTranslation } from "react-i18next";
import { Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { ViewIcon } from "../../../common/icons";
import BadgeComponent from "../../../common/badge";
import { govtIDcardLength, mobileNoMaxLength } from "../../../common/commonValidations";
import apiClient from "../../../axios";

function DeliveryChalanList(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { state } = useLocation();
    const [stakeholderDetails, setStakeholderDetails] = useState();
    const [tabValue, setTabValue] = useState('');
    //const decoded = jwt(getLocalStorageItem('id_token'));
    const [asnDetails, setAsnDetails] = useState([]);
    const [consignmentStatusList, setConsignmentStatusList] = useState();
    const [selected, setSelected] = useState(asnDetails);
    const [pickUpDate, setPickUpDate] = React.useState(new Date());
    const [searchFilter, setSearchFilter] = useState({
        "challanDate": null,
        "vehicleRegNo": null

    });
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [deliveryChallanList, setDeliveryChallanList] = useState();

    useEffect(() => {
        if (stakeholderDetails && stakeholderDetails?.category === 'LLE') {
            setTabValue('ChipBamboo');
        } else if (state?.tabValue) {
            setTabValue(state.tabValue);
        } else {
            setTabValue('RawBamboo');
        }
    }, [stakeholderDetails, state]);

    const onViewDetails = (cellValues) => {
        navigate('./DeliveryChalanDetails', {
            state: { selectedRow: cellValues.row, tabValue: tabValue }
        });
    }

    
    useEffect(() => {
        if (decoded.extension_URN) {
            getStakeDetails();
        }
    }, [decoded.extension_URN]);

    useEffect(() => {
        if (stakeholderDetails || tabValue) {
            getDeliveryChallanList();
        }
    }, [stakeholderDetails, tabValue]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        // getDeliveryChallanList(stakeholderDetails, newValue)
    };

    function getStakeDetails() {
        apiClient
            .post(GET_STAKEHOLDER_CATEGORY,
                {
                    "urn": decoded.extension_URN,
                    "type": ""
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setStakeholderDetails(response.data);
                // getDeliveryChallanList(response.data, tabValue);
            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.message);

            });
    }


    const getDeliveryChallanList = () => {
        loaderService.showLoader()
        apiClient
            .post(GET_DELIVERY_CHALLAN_LIST,
                {
                    "stakeholderUrn": decoded.extension_URN ? decoded.extension_URN : getLocalStorageItem('role') === PIT_ROLES?.PlantSCMOperator ? "ABEPL" : '',
                    "stakeholderType": stakeholderDetails?.category ? stakeholderDetails?.category : getLocalStorageItem('role') === PIT_ROLES?.PlantSCMOperator ? "Plant" : '', 
                    // "challanDate": "",
                    // "vehicleRegNo": ""
                    "challanDate": searchFilter?.challanDate ? searchFilter?.challanDate : null,
                    "vehicleRegNo": searchFilter?.vehicleRegNo ? searchFilter?.vehicleRegNo : null,
                    "materialType": tabValue ? tabValue : tabValue,
                    "destinationStakeholderType": getLocalStorageItem('role') === PIT_ROLES?.LLESCMOperator ? "LLE" : ''
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setDeliveryChallanList(response.data.deliveryChallanList);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }
    function searchChallan(e) {
        e.preventDefault();
        getDeliveryChallanList();
    }
    const handleChange = (e) => {
        if (e.target.name === "vehicleRegNo") {
            setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value })
        }
    }

    const viewdownloadDocument = (documentBlobName, finalfileName, type) => {
        loaderService.showLoader();
        return fetch(DOWNLOAD_DOCUMENT,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    AuthKey: authKey,
                },
                body: JSON.stringify({
                    "fileName": documentBlobName,
                    "containerName": "pit",
                    "file": ""
                })
            })
            .then((response) => response.blob()
            )
            .then((blob) => {
                if (type === "View") {
                    const fileName = finalfileName
                    const splittedName = fileName.split('.')
                    const fileExtension = splittedName[splittedName.length - 1];
                    let fileType;
                    switch (fileExtension) {
                        case 'pdf':
                            fileType = 'application/pdf';
                            break;
                        case 'png':
                            fileType = 'image/png';
                            break;
                        case 'jpg':
                            fileType = 'image/jpeg';
                            break;
                        case 'jpeg':
                            fileType = 'image/jpeg';
                            break;
                        default:
                            fileType = 'application/octet-stream';
                    }
                    const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
                    const newWindow = window.open(url, '_blank');
                    newWindow.focus();
                }
                else {
                    const a = document.createElement("a");
                    a.style.display = "none";
                    document.body.appendChild(a);
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = finalfileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }

    const columns = [
        { field: 'challanNo', headerName: 'Delivery Challan No.', width: 160 },
        {
            field: 'challanDate', headerName: t('reg.date'), width: 130,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'consignmentNo', headerName: 'Consignment No', width: 150 },
        { field: 'consignmentStatus', headerName: 'Consignment Status', width: 180 },
        { field: 'consignmentSourceStakeholderUrn', headerName: 'Source URN', width: 150 },
        { field: 'consignmentSourceStakeholderName', headerName: 'Source Name', width: 180 },
        { field: 'consignmentDestinationStakeholderUrn', headerName: 'Destination URN', width: 150 },
        { field: 'consignmentDestinationStakeholderName', headerName: 'Destination Name', width: 250 },
        { field: 'vehicleRegNo', headerName: 'Vehicle No.', width: 150 },
        { field: 'expectedQuantity', headerName: 'Pickup Quantity (in MT)', width: 160 },
        {
            field: 'vehicleRegFileId', headerName: 'Vehicle Registration Document', width: 220,
            renderCell: (params) => {
                if (params.value === null) return "-";
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Link
                            // key={index}
                            onClick={(e) => viewdownloadDocument(params?.row?.vehicleRegFileId, params?.row?.vehicleRegFileName, "Download")}
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                        >
                            {params?.row?.vehicleRegFileName}
                        </Link>
                    </div>
                );
            }
        },
        {
            field: 'licenseFileId', headerName: 'Driving License Document', width: 200,
            renderCell: (params) => {
                if (params.value === null) return "-";
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Link
                            // key={index}
                            onClick={(e) => viewdownloadDocument(params?.row?.licenseFileId, params?.row?.licenseFileName, "Download")}
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                        >
                            {params?.row?.licenseFileName}
                        </Link>
                    </div>
                );
            }

        },
        {
            field: 'Action', width: 120,
            renderCell: (cellValues) => {
                return (
                    <Tooltip title="View">
                        <IconButton variant="contained"
                            color="primary"
                            onClick={() => onViewDetails(cellValues)}>
                            <ViewIcon />
                        </IconButton>
                    </Tooltip>
                );
            }
        },
    ];
    // const handleDateChange = (date) => {
    //     setPickUpDate(date);
    //     console.log(pickUpDate)
    //     //  getconsignmentDetails(date);
    // }
    const handleDateChange = (e) => {
        setSearchFilter({ ...searchFilter, "challanDate": e.format("YYYY-MM-DD") })
    }

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT19</p>}
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h5" gutterBottom>
                        Delivery Challan List
                    </Typography>
                </Stack>
                <Card>
                    <CardContent>
                        <Grid container spacing={1} >
                            <Grid item xs={12} lg={3}>
                                <FormControl >
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            label="Delivery Challan Date"
                                            inputFormat="DD/MM/YYYY"
                                            value={searchFilter?.challanDate}
                                            onChange={(e) => { handleDateChange(e) }}
                                            renderInput={(params) => <TextField size="small"  {...params} />}
                                            sx={{ minWidth: 750 }}
                                        /></LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={3}>
                                <TextField fullWidth size="small"
                                    label="Vehicle No"
                                    name="vehicleRegNo"
                                    value={searchFilter.vehicleRegNo}
                                    onChange={(e) => handleChange(e)}
                                    sx={{ paddingRight: '3%' }}
                                    inputProps={{
                                        maxLength: "20"
                                    }}
                                />
                                <BadgeComponent currentLength={searchFilter?.vehicleRegNo?.length} maxLength={govtIDcardLength} />
                            </Grid>
                            <Grid item xs={12} lg={3}>
                                <Button variant="contained" startIcon={<SearchIcon />}
                                    color="primary" onClick={(e) => searchChallan(e)} >
                                    Search
                                </Button>
                                {/* <Button style={{ border: "0.2vh solid #000000", height: "7vh", borderRadius: "1vh" }} onClick={(e) => searchChallan(e)}>
                                            <SearchIcon />
                                        </Button> */}
                            </Grid>
                        </Grid>
                        <TabContext value={tabValue}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleTabChange}>
                                    {stakeholderDetails?.category !== "LLE" && <Tab label="Raw Bamboo" value="RawBamboo" />}
                                    {!props?.onlyRb && <Tab label="Chip Bamboo" value="ChipBamboo" />}
                                </TabList>
                            </Box>
                            <TabPanel value="RawBamboo">
                                <Box style={{ height: 500, width: '100%', marginTop: "2vh" }}>
                                    {
                                        deliveryChallanList &&
                                        <DataGrid rows={deliveryChallanList}
                                            getRowHeight={() => 'auto'}
                                            columns={columns}
                                            pageSize={10}
                                            //getRowId={(row) => row.consignmentNo}
                                            components={{ Toolbar: QuickSearchToolbar }}
                                        />
                                    }
                                </Box>
                            </TabPanel>
                            <TabPanel value="ChipBamboo">
                                <Box style={{ height: 500, width: '100%', marginTop: "2vh" }}>
                                    {
                                        deliveryChallanList &&
                                        <DataGrid rows={deliveryChallanList}
                                            getRowHeight={() => 'auto'}
                                            columns={columns}
                                            pageSize={10}
                                            //getRowId={(row) => row.consignmentNo}
                                            components={{ Toolbar: QuickSearchToolbar }}
                                        />
                                    }
                                </Box>
                            </TabPanel>
                        </TabContext>
                    </CardContent>
                </Card>
            </Container>
        </>
    );
}
export default DeliveryChalanList;
